export const START_PLAY = 'START_PLAY';
export const END_PLAY = 'END_PLAY';
export const NEXT_PAGE = 'NEXT_PAGE';
export const PREV_PAGE = 'PREV_PAGE';
export const NEXT_PAGE_WITHOUT_FRAGMENT = 'NEXT_PAGE_WITHOUT_FRAGMENT';
export const PREV_PAGE_WITHOUT_FRAGMENT = 'PREV_PAGE_WITHOUT_FRAGMENT';
export const JUMP_PAGE = 'JUMP_PAGE';
export const SHOW_DIALOG = 'SHOW_DIALOG';
export const HIDE_DIALOG = 'HIDE_DIALOG';
export const TURN_ON_LASER = 'TURN_ON_LASER';
export const TURN_OFF_LASER = 'TURN_OFF_LASER';
export const TURN_ANNOTATION = 'TURN_ANNOTATION';
export const BE_MASTER = 'BE_MASTER';
export const BE_AUDIENCE = 'BE_AUDIENCE';
export const END_REMOTE_PLAY = 'END_REMOTE_PLAY';

export const MASTER_PEN_UPDATED = 'MASTER_PEN_UPDATED'; // 激光笔位置更新
export const SENT_PEN_DATA = 'SENT_PEN_DATA'; // 已发送激光笔数据
export const AUDIENCE_PEN_DRAWING = 'AUDIENCE_PEN_DRAWING'; // 客态绘制激光笔

export const SLIDE_SCALE_CHANGED = 'SCALE_CHANGED'; // Slide的Scale改变

export const NEXT_PAGE_REMOTE = 'NEXT_PAGE_REMOTE';
export const PREV_PAGE_REMOTE = 'PREV_PAGE_REMOTE';
export const JUMP_PAGE_REMOTE = 'JUMP_PAGE_REMOTE';
export const ALLOW_FLIP_PAGE = 'ALLOW_FLIP_PAGE';
export const FORIBD_FLIP_PAGE = 'FORIBD_FLIP_PAGE';
export const SYCN_WITH_MASTER = 'SYCN_WITH_MASTER'; // 与演讲者同步进度

export const MASTER = 'master';
export const AUDIENCE = 'audience';

export const INIT_CLIENT_WIDTHHEIGHT = 'INIT_WIDTH_HEIGHT';
export const INTERACTIVE_ANIM_NEXT = 'INTERACTIVE_ANIM_NEXT';
export const INTERACTIVE_ANIM_RESET = 'INTERACTIVE_ANIM_RESET';
export const STOP_MAIN_ANIM = 'STOP_MAIN_ANIM';
export const HANDLE_FIRST_ANIM_WITH_EFFECT = 'HANDLE_FIRST_ANIM_WITH_EFFECT';
export const START_TRANSITION = 'START_TRANSITION';
export const STOP_TRANSITION = 'STOP_TRANSITION';
export const SHOULD_STOP_TRANSITION = 'SHOULD_STOP_TRANSITION';

